/// <reference path="../../../src/types.d.ts" />
const rulesListPath = {
    displayName: 'Rules',
    path: '/cmx/admin/rules/'
};
const dmnViewerPath = {
    displayName: 'Decision Definition DMN',
    path: '/cmx/admin/rules/:taskId/'
};
export const rulesPaths = [
    rulesListPath,
    dmnViewerPath
];
export const rulesList = {
    decisionDefinitions: [],
    selectedDecisionName: '',
    selectedDiagramXML: ''
};
